import classNames from 'classnames'
import React from 'react'
import ChevronDown from 'wix-ui-icons-common/ChevronDown'
import sc from '../../../../../../classes.scss'
import {MobileMonthlyEventDetails} from './details'
import s from './mobile-monthly-event.scss'
import {MobileMonthlyEventProps} from '.'

export class MobileMonthlyEvent extends React.PureComponent<MobileMonthlyEventProps> {
  handleEventClick = () => {
    const {event, openMonthlyCalendarEvent} = this.props
    openMonthlyCalendarEvent(event.id)
  }

  renderShortEventInfo() {
    const {event, eventTime} = this.props

    return (
      <div
        className={classNames(s.container, sc.textLineHeight)}
        onClick={this.handleEventClick}
        data-hook={`event-${event.id}`}
      >
        <div className={s.time} data-hook={`event-time-${event.id}`}>
          {eventTime}
        </div>
        <div className={s.title} data-hook={`event-title-${event.id}`}>
          {event.title}
          <div className={s.chevron}>
            <ChevronDown size="1.2em" />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {selectedEventId, event} = this.props

    if (selectedEventId === event.id) {
      return <MobileMonthlyEventDetails event={event} />
    } else {
      return this.renderShortEventInfo()
    }
  }
}
